<template>

    <div class="website::admin-websitePages-createEdit-moduleEditor-Toolbar">

        <div class="px-5 py-10 sm:px-10">
            <h4 class="text-2xl font-bold">{{ title }}</h4>
            <h6 class="text-lg text-gray-500">{{ instruction }}</h6>
        </div>

        <div class="col-8 d-flex align-items-center text-right" v-if="$slots.actions">
            <slot name="actions"/>
        </div>

    </div>

</template>

<script>

export default {
    props: {
        title: String,
        instruction: String,
    }
}

</script>

<style lang="scss" scoped>

.website\:\:admin-websitePages-createEdit-moduleEditor-Toolbar {

    .heading {
        border-bottom: 1px solid #eee;
    }

}

</style>
